import './style.scss';
import he from 'he';

function adjustLinerNoteContainers() {
  const LinerNoteContainers = document.querySelectorAll('.notes-list-container');
  LinerNoteContainers.forEach(container => {
    const containerContents = Array.from(container.children).filter(child => !child.classList.contains('sonata-movement-list'));
    const containerHeight = container.offsetHeight;
    const pHeight = Array.from(containerContents).reduce((total, current) =>
      total 
    + current.offsetHeight 
    + (parseInt(window.getComputedStyle(current).getPropertyValue('margin-block').replace('px','')) * 2),
    0);
    let trackListHeight = 0;
    const trackList = container.querySelector('.sonata-movement-list');
    if (trackList) {
      trackListHeight = container.querySelector('.sonata-movement-list').offsetHeight || 0;
    }
    console.log({ pHeight, containerHeight, trackListHeight })
    if (pHeight < containerHeight) {
      const newContainerHeight = Math.max(pHeight, trackListHeight)
      container.setAttribute('style', `height: ${newContainerHeight}px !important;`);
    }
  });
}

const buttonIcons = {
  loading: '<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#FFFFFF"><path d="M480-62q-86.72 0-162.77-32.82-76.05-32.81-132.82-89.59-56.78-56.77-89.59-132.82Q62-393.28 62-480q0-86.82 32.78-162.66t89.49-132.85q56.72-57.01 132.74-89.75Q393.04-898 479.69-898 505-898 522-881q17 17 17 41.51 0 24.51-17 42T480-780q-124.69 0-212.34 86.99Q180-606.02 180-480.51t87.65 213.01Q355.31-180 479.99-180 606-180 693-267.66q87-87.65 87-212.34 0-25 17.49-42t42-17Q864-539 881-522q17 17 17 42.31 0 86.65-32.8 162.69-32.81 76.04-89.56 132.8-56.76 56.77-132.72 89.48Q566.96-62 480-62Z"/></svg>',
  pause: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M320-273v-414q0-17 12-28.5t28-11.5q5 0 10.5 1.5T381-721l326 207q9 6 13.5 15t4.5 19q0 10-4.5 19T707-446L381-239q-5 3-10.5 4.5T360-233q-16 0-28-11.5T320-273Z"/></svg>',
  play: '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M636-228q-29.7 0-50.85-21.15Q564-270.3 564-300v-360q0-29.7 21.15-50.85Q606.3-732 636-732h24q29.7 0 50.85 21.15Q732-689.7 732-660v360q0 29.7-21.15 50.85Q689.7-228 660-228h-24Zm-336 0q-29.7 0-50.85-21.15Q228-270.3 228-300v-360q0-29.7 21.15-50.85Q270.3-732 300-732h24q29.7 0 50.85 21.15Q396-689.7 396-660v360q0 29.7-21.15 50.85Q353.7-228 324-228h-24Z"/></svg>',
  dead: '<svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px" fill="#FFFFFF"><path d="m348.54-539.77 30.38 30.39q3.93 5.69 12.46 5.69 8.54 0 14.24-5.93 4.69-4.92 4.69-12.84t-5.69-13.62l-30.85-31.84 30.85-31.39q4.92-4.92 5.8-12.84.89-7.93-4.8-13.62-5.7-5.15-14.24-4.77-8.53.39-13.69 5.54l-29.15 29.15-34.08-30.61q-5.92-5.69-13.96-5.08-8.04.62-13.73 6.54-4.69 4.92-4.69 12.85 0 7.92 4.92 11.84l32.62 32.39L287-535.31q-4.92 4.93-4.42 12.85t6.19 13.84q4.69 5.16 12.35 5.66 7.65.5 13.57-5.19l33.85-31.62Zm262.92 0 35.08 31.85q4.15 5.69 12.19 4.96 8.04-.73 13.73-7.66 4.69-3.92 4.69-11.34t-4.92-13.12l-30.85-32.84 30.85-32.39q3.92-3.92 3.92-11.84 0-7.93-4.69-13.85-5.69-5.15-13.34-5.65-7.66-.5-13.58 3.19l-33.08 32.61L581.31-626q-4.93-5.15-13.46-5.04-8.54.12-12.47 5.04-5.69 5.92-5.19 13.85.5 7.92 5.43 12.84l30.61 31.39-31.61 32.61q-4.93 4.93-4.93 12.85t4.69 12.84q5.7 4.93 13.85 5.04 8.15.12 14.08-5.8l29.15-29.39ZM480-104q-77.54 0-146.23-29.04-68.69-29.04-120.19-80.54-51.5-51.5-80.54-120.19Q104-402.46 104-480q0-77.54 29.04-146.12 29.04-68.57 80.54-119.3 51.5-50.73 120.19-80.66Q402.46-856 480-856q77.54 0 146.12 29.92 68.57 29.93 119.3 80.66 50.73 50.73 80.66 119.3Q856-557.54 856-480t-29.92 146.23q-29.93 68.69-80.66 120.19t-119.3 80.54Q557.54-104 480-104Zm0-376Zm0 332.23q138.38 0 235.31-96.92 96.92-96.93 96.92-235.31t-96.92-235.31Q618.38-812.23 480-812.23t-235.31 96.92Q147.77-618.38 147.77-480t96.92 235.31q96.93 96.92 235.31 96.92Zm0-269.77q-52.31 0-96.77 25-44.46 25-72.38 66.31-7.23 11.69-.39 21.65 6.85 9.96 18.54 9.96h302q10.69 0 17.54-9.96 6.84-9.96.84-21.65-28.92-41.54-73.5-66.42-44.57-24.89-95.88-24.89Z"/></svg>',
}
let albumMusicData;
let currentMusicData = {};
const audioEl = document.getElementById('audioEl');
const mediaPlayer = {
  labels: {
    composer: document.getElementById('mediaPlayerComposer'),
    movement: document.getElementById('mediaPlayerTitle'),
    piece: document.getElementById('mediaPlayerParentPiece'),
  },
  playback: {
    playButton: document.getElementById('playPause'),
    skipNextButton: document.getElementById('skipNext'),
    skipPreviousButton: document.getElementById('skipPrevious'),
  },
  progress: {
    currentTimeDisplay: document.getElementById('mediaProgressTime'),
    totalTimeDisplay: document.getElementById('mediaRemainingTime'),
    progressBar: document.getElementById('mediaPlayerProgress'),
    progressContainer: document.getElementById('mediaPlayerProgressParent'),
  },
  volume: {
    muteButton: document.getElementById('volumeButton'),
    volumeSlider: document.getElementById('volumeBar'),
  }
}

let buffering = false;
let isDragging = false;
let isPlaying = false;

audioEl.addEventListener('canplay', () => {
  buffering = false;
  if (!isDragging) {
    if (isPlaying) {
      changeAudioState('play');
    } else {
      changeAudioState('pause');
    }
  }
});
audioEl.addEventListener('waiting', () => {
  if (!buffering) {
    buffering = true;
    changeAudioState('loading', isDragging ? -1 : 2);
  }
});

window.onload = () => {
  document.getElementsByTagName('footer')[0].style.marginBlockEnd = '52px';
  adjustLinerNoteContainers();
  albumMusicData = JSON.parse(document.getElementById('music-data').textContent);
  console.log(albumMusicData);
  document.querySelectorAll('[data-music-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const musicId = button.dataset.musicId;
      const buttonMusicData = albumMusicData[musicId];
      if (buttonMusicData.url) {
        // If switching to a new button
        if (currentMusicData.url === undefined || buttonMusicData.url !== currentMusicData.url) { 
          setCurrentMusicData(buttonMusicData);
        }
        else {
          togglePlayPause()
        }
      } else {
        updatePlayIconState('dead', 0, buttonMusicData.order);
      }
    })
  });

  mediaPlayer.playback.playButton.addEventListener('click', () => {
    togglePlayPause();
  });

  mediaPlayer.playback.skipNextButton.addEventListener('click', () => {
    if (albumMusicData[parseInt(currentMusicData.order) + 1]) {
      setCurrentMusicData(albumMusicData[parseInt(currentMusicData.order) + 1]);
    }
  })
  mediaPlayer.playback.skipPreviousButton.addEventListener('click', () => {
    if (albumMusicData[parseInt(currentMusicData.order) - 1]) {
      setCurrentMusicData(albumMusicData[parseInt(currentMusicData.order) - 1]);
    }
  })
  // Mouse event listeners
  mediaPlayer.progress.progressContainer.addEventListener('mousedown', startDragging);
  window.addEventListener('mouseup', stopDragging);
  // Touch event listeners
  mediaPlayer.progress.progressContainer.addEventListener('touchstart', startDragging);
  window.addEventListener('touchend', stopDragging);

  preloadMusicData(albumMusicData[1]);
};
let wasPlaying = false;
let dragStart = false;
// When the mouse is pressed down or touched
function startDragging(event) {
  wasPlaying = isPlaying;
  if(event.type.startsWith('touch')) {
    window.addEventListener('touchmove', moveProgress);
  } else {
    window.addEventListener('mousemove', moveProgress);
  }
    isDragging = true;
    dragStart = true;
    updateProgress(event);
}


// When the mouse moves or the finger moves on the screen
function moveProgress(event) {
    if (isDragging) {
        if (dragStart === true) {
          changeAudioState('pause', -1);
          dragStart = false;
        }
        updateProgress(event, wasPlaying);
    }
}

// When the mouse button is released or the touch ends
function stopDragging(event) {
  if(event.type.startsWith('touch')) {
    window.removeEventListener('touchmove', moveProgress);
  } else {
    window.removeEventListener('mousemove', moveProgress);
  }
  if (isDragging) {
    changeAudioState(wasPlaying ? 'play' : 'pause', -1);
    isDragging = isDragging = false;
  }
}
function updateProgress(event) {
  // Handle both mouse and touch events
  const clientX = event.type.startsWith('touch') ? event.touches[0].clientX : event.clientX;
  const rect = mediaPlayer.progress.progressContainer.getBoundingClientRect();
  const xWithinElement = clientX - rect.left;
  const width = rect.width; // Can use rect.width directly
  const percentage = (xWithinElement / width) * 100;

  // Ensure the percentage is within 0% to 100%
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);
  audioEl.currentTime = (clampedPercentage / 100) * audioEl.duration;
  mediaPlayer.progress.progressBar.style.width = clampedPercentage + '%';
}

function setCurrentMusicData(newMusicData, playOnSet=true) {
  changeAudioState('pause');
  audioEl.currentTime = 0;
  mediaPlayer.progress.totalTimeDisplay.textContent = formatTime(0);
  currentMusicData = newMusicData;
  // updatePlayingSignalLocation();
  changeAudioState('loading');
  refreshMediaPlayerLables();
  if (currentMusicData.url === '') {
    audioEl.src = null;
    changeAudioState('dead');
  } else {
    audioEl.src = currentMusicData.url;
    if (playOnSet) {
      isPlaying = true;
    }
  }
}

function updatePlayingSignalLocation() {
  let oldPlayingSignal = document.getElementById('playingSignal');
  if (oldPlayingSignal) {
    document.getElementById('playingSignal').remove();
  }
  const newPlayingSignal = createPlayingSignal();
  document.querySelectorAll(`.sonata-track-main[data-button-id="${currentMusicData.order}"]`).forEach((track) => {
    track.append(newPlayingSignal);
  })
}

function createPlayingSignal() {
  const span = document.createElement('span');
  span.setAttribute('id', 'playingSignal');
  span.textContent = 'now playing...'
  return span;
}

function preloadMusicData(musicData) {
  setCurrentMusicData(musicData, false);
}

function refreshMediaPlayerLables() {
  mediaPlayer.labels.piece.textContent = he.decode(currentMusicData.pieceTitle);
  mediaPlayer.labels.composer.textContent = he.decode(currentMusicData.composerTitle);
  mediaPlayer.labels.movement.textContent = he.decode(currentMusicData.movementTitle);
  audioEl.addEventListener('loadedmetadata', loadDurationData);
  switch (currentMusicData.order) {
    case '1':
      mediaPlayer.playback.skipPreviousButton.classList.add('disabled');
      break;
    case '' + Object.keys(albumMusicData).length:
      mediaPlayer.playback.skipNextButton.classList.add('disabled');
      break;
    default:
      mediaPlayer.playback.skipPreviousButton.classList.remove('disabled');
      mediaPlayer.playback.skipNextButton.classList.remove('disabled');
  }
}
function loadDurationData() {
  mediaPlayer.progress.totalTimeDisplay.textContent = formatTime(audioEl.duration);
  audioEl.removeEventListener('loadedmetadata', loadDurationData);
}

function togglePlayPause() {
  if (!buffering && audioEl.src) {
    if (isPlaying) {
      changeAudioState('pause');
    } else {
      changeAudioState('play');
    }
  }
}

/**
 * 
 * @param {'play' | 'pause' | 'loading' | 'dead'} state 
 * @param {-1 | 0 | 1 | 2} selector 
 */
function changeAudioState(state, selector=2) {
  if (['play', 'pause', 'loading'].includes(state)) {
    // Only call play or pause on the audio element
    switch (state) {
      case 'pause':
        audioEl.pause();
        isPlaying = false;
        updatePlayIconState('pause', selector);
        break;
      case 'play':
        audioEl.play().then(() => {
          isPlaying = true;
        updatePlayIconState('play', selector);
        }).catch((err) => console.log('err:', err));
        break;
      case 'loading':
        updatePlayIconState('loading', selector);
      default:
        break;
    }
  } else {
    updatePlayIconState('dead')
    currentMusicData['dead'] = true;
  }
}

// Function to format time as mm:ss
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return minutes + ":" + (remainingSeconds < 10 ? "0" : "") + remainingSeconds;
}

// Event listener to update the displayed time
audioEl.addEventListener('timeupdate', () => {
  const currentTime = audioEl.currentTime;
  mediaPlayer.progress.currentTimeDisplay.textContent = formatTime(currentTime);
  mediaPlayer.progress.progressBar.style.width = audioEl.duration ? `${(currentTime/audioEl.duration) * 100}%` : 0;
  if (audioEl.ended) {
    updatePlayIconState('pause');
  }
});

/**
 * If selector = 0: The function updates buttons with data-music-id.
 * 
 * If selector = 1: The function only updates playButtonMain.
 * 
 * If selector = 2: The function updates both.
 * @param {string} icon 
 * @param {int} selector 
 */
function updatePlayIconState(icon, selector=2, order=currentMusicData.order) {
  if (selector < 0) {
    return;
  }
  if (icon === 'dead') {
    mediaPlayer.playback.playButton.classList.add('disabled');
    document.querySelectorAll(`[data-music-id="${order}"]`).forEach((button) => {
      button.classList.add('disabled');
    });
  } else if (!currentMusicData.dead) {
    mediaPlayer.playback.playButton.classList.remove('disabled');
    document.querySelectorAll(`[data-music-id="${order}"]`).forEach((button) => {
      button.classList.remove('disabled');
    });
  }
  if (selector % 2 === 1 || selector > 1) {
    mediaPlayer.playback.playButton.innerHTML = buttonIcons[icon];
  }
  if (selector % 2 === 0) {
    if (!currentMusicData.dead) {
      document.querySelectorAll(`[data-music-id="${order}"]`).forEach((button) => {
        button.innerHTML = buttonIcons[icon];
      });
    }
  }
}